<template>
    <table class="table is-fullwidth is-striped has-text-centered is-hoverable">
        <thead>
            <tr>
                <th class="has-text-centered"></th>
                <th class="has-text-centered">Status</th>
                <th class="has-text-centered">Rules</th>
                <th class="has-text-centered">Date</th>
                <th class="has-text-centered">Tail</th>
                <th class="has-text-centered">PIC</th>
                <th class="has-text-centered">SIC</th>
                <th class="has-text-centered">Schedule</th>
                <th class="has-text-centered">Times</th>
                <th class="has-text-centered">FMS</th>
                <th class="has-text-centered">Fuel</th>
                <th class="has-text-centered">Pilot</th>
                <th class="has-text-centered">W&B</th>
                <th class="has-text-centered"></th>
            </tr>
        </thead>
        <tbody>
            <leg-row v-for="leg in filteredLegs" :key="leg.id" :leg="leg"></leg-row>
        </tbody>
    </table>
</template>

<script>
import LegRow from './LegRow.vue';

export default {
    name: 'LegsTable',

    components: { LegRow },
    props: {
        legs: {
            type: Array,
            required: true
        },
        filter: {
            type: String,
            required: true
        }
    },
    computed: {
        filteredLegs() {
            const now = new Date();
            const filtered = this.filter === 'all' 
                ? this.legs 
                : this.filter === 'review'
                    ? this.legs.filter(leg => ['failed', 'warning'].includes(leg.status))
                    : this.legs.filter(leg => leg.status === this.filter);
            
            return filtered
                .filter(leg => new Date(leg.arrivalDateTime) <= now)
                .sort((a, b) => new Date(a.departureDateTime) - new Date(b.departureDateTime));
        }
    }
}
</script>